import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { ToggleSection } from '../Accordion';
import { QuicklinksLink } from './';
import styles from './index.css';

const QuicklinksSection = props => {
  const { title, collapsible, links, className } = props;
  if (collapsible) {
    return (
      <FormattedMessage id={title}>
        {translatedTitle => {
          return (
            <ToggleSection
              className={classnames(styles.toggleSection, className)}
              header={translatedTitle}
            >
              <div className={styles.toggleContent}>
                {links.map(function(link, i) {
                  return <QuicklinksLink key={i} link={link} />;
                })}
              </div>
            </ToggleSection>
          );
        }}
      </FormattedMessage>
    );
  } else {
    return (
      <div className={classnames(styles.section, className)}>
        <div className={styles.title}>
          <FormattedMessage id={title}>{text => text}</FormattedMessage>
        </div>
        {links.map(function(link, i) {
          return <QuicklinksLink key={i} link={link} />;
        })}
      </div>
    );
  }
};

QuicklinksSection.displayName = 'QuicklinksSection';

QuicklinksSection.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  collapsible: PropTypes.bool,
  links: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default QuicklinksSection;
